import {
  Box,
  Grid,
  IconButton,
  ListItem,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { CiFileOn } from "react-icons/ci";
import { Enumerations } from "../../config/Enumerations";
import { VscOpenPreview } from "react-icons/vsc";
import React from "react";
import { AppEntryAttachmentsRepository } from "../repositories/AppEntryAttachmentsRepository";
import { LiaDownloadSolid } from "react-icons/lia";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { useDispatch } from "react-redux";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import PDFDialogViewer from "../common/PdfDialogViewer";

export default function EntryDecisions({ appEntry }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [previewPdf, setPreviewPdf] = React.useState(null);
  const [imagePreview, setImagePreview] = React.useState(null);
  const [dwgPreview, setDwgPreview] = React.useState(null);

  const previewDocument = (document) => {
    console.log(document);
    AppEntryAttachmentsRepository.getDecision(document.id)
      .then((response) => {
        const file = new Blob([response.data], { type: response.data.type });
        if (document.fileType === "application/pdf") {
          setPreviewPdf(file);
        }
        if (document.fileType.startsWith("image/")) {
          setImagePreview(URL.createObjectURL(file));
        }
        // TODO: implement DWG preview
        // if (
        //   document.fileType.startsWith("application/octet-stream") &&
        //   document.fileName.endsWith(".dwg")
        // ) {
        //   setDwgPreview(URL.createObjectURL(file));
        //   window.open(
        //     "https://sharecad.org/cadframe/load?url=" +
        //       URL.createObjectURL(file),
        //     "_blank"
        //   );
        // }
      })
      .catch((error) => {
        console.error("Error downloading document:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      });
  };

  const downloadDocument = (doc) => {
    console.log(doc);
    AppEntryAttachmentsRepository.getDecision(doc.id)
      .then((response) => {
        const file = new Blob([response.data], { type: response.data.type });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", doc.fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading doc:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      });
  };

  return (
    <Grid item xs={12} md={6}>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <div
          className="entry-decisions-title"
          style={{ borderLeft: `4px solid ${theme.palette.primary.main}` }}
        >
          <Typography
            variant="h6"
            style={{ color: theme.palette.secondary.main }}
          >
            Одлуки и решенија
          </Typography>
        </div>
        <Grid item xs={12} padding={1}>
          {appEntry?.docs?.length > 0 && (
            <Box className="other-documents-box">
              {appEntry?.docs
                ?.filter((d) => d.documentType == "FINAL_SIGNED_DOC")
                .map((doc, index) => (
                  <ListItem key={index} className="document-item dark-border">
                    <div className="document-icon">
                      <CiFileOn color="#2d2d2d" size={25} />
                    </div>
                    <div className="document-details">
                      <Typography
                        variant="inherit"
                        className="document-type dark"
                      >
                        {Enumerations.DocumentType[doc.documentType] ||
                          doc.type}
                      </Typography>
                      <Typography
                        variant="inherit"
                        className="document-name dark"
                      >
                        {doc.fileName}
                      </Typography>
                    </div>
                    <div className="document-actions">
                      <IconButton
                        className="document-icon-button"
                        onClick={() => previewDocument(doc)}
                      >
                        <VscOpenPreview color="#2d2d2d" />
                      </IconButton>
                      <IconButton
                        className="document-icon-button"
                        onClick={() => downloadDocument(doc)}
                      >
                        <LiaDownloadSolid color="#2d2d2d" />
                      </IconButton>
                    </div>
                  </ListItem>
                ))}
            </Box>
          )}
        </Grid>
      </Paper>
      {previewPdf && (
        <PDFDialogViewer
          openPdfDialog={previewPdf}
          setOpenPdfDialog={setPreviewPdf}
          pdfBlob={previewPdf}
        />
      )}
    </Grid>
  );
}
